'use strict';

import Base from './Base';

function _setReadOnly(key){

  var descriptor = Object.getOwnPropertyDescriptor(this, key);

  if(descriptor){
    descriptor.writable = false;
    descriptor.configurable = false;
  }

  Object.defineProperty(this, key, descriptor);

}

function _setNoneEnumerable(key){

  var descriptor = Object.getOwnPropertyDescriptor(this, key);

  if(descriptor){
    descriptor.enumerable = false;
  }

  Object.defineProperty(this, key, descriptor);

}

function _setNoneEnumerableAndReadOnly(key){

  var descriptor = Object.getOwnPropertyDescriptor(this, key);

  if(descriptor){
    descriptor.enumerable = false;
    descriptor.writable = false;
    descriptor.configurable = false;
  }

  Object.defineProperty(this, key, descriptor);

}

function _getParameterNames(key){

  const COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;

  var fn = this[key];
  var code = fn.toString().replace(COMMENTS, '');

  var result = [];
  result = (code || []).slice(code.indexOf('(') + 1, code.indexOf(')'))
            .match(/([^\s,]+)/g);

  if(result){

    result = result.map((param) => {

      if(param.indexOf('_') === 0){

        var clean = param.substr(1, param.length);
        if(clean === key){
          param = clean;
        }

      }

      return param;

    });

  }else{
    result = [];
  }

  return result;

}

function _keys(){
  return [...Reflect.enumerate(this)];
}

function _propertyDescription(key){

  var value = this[key];
  if(typeof value === 'string'){
    value = '\'' + value + '\'';
  }

  return `${key}: ${value} <${typeof value}>`;

}

function _functionDescription(key){
  var params = _getParameterNames.call(this, key).join(', ');
  return `${key}(${params})`;
}

function _validateKey(key){

  let keys = _keys.call(this);

  if(keys.indexOf(key) === -1){
    throw new Error(`property '${key}' not found on ${this.className}`);
  }

}

function _validateFunction(key){

  if(typeof this[key] === 'function'){
    throw new Error(`cannot set a function: ${key}()`);
  }

}

function _setValue(key, value){

  var type = typeof this[key];

  try{

    if(type === 'number'){

      this[key] = parseInt(value);

    }else if(type === 'boolean'){

      if(value === 0 || value === '0'){
        value = false;
      }else if(value === 1 || value === '1'){
        value = true;
      }

      this[key] = JSON.parse(value);

    }else if(type === 'string'){

      this[key] = value + '';

    }else{

      this[key] = value;

    }

  }catch(err){ //eslint-disable-line no-empty
    //console.warn('\n' + err + '\n');
  }

}


////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function get(key){

  _validateKey.call(this, key);

  return this[key];

}

function setReadOnly(key){
  return _setReadOnly.call(this, key);
}

function set(...args){

  if(typeof args[0] === 'object'){

    var obj = args[0];

    for(let key in obj){
      set.call(this, key, obj[key]);
    }

  }else{

    let key = args[0];
    let value = args[1];

    _validateKey.call(this, key);
    _validateFunction.call(this, key);

    _setValue.call(this, key, value);

  }

  return this;

}

function init(options){

  var readonly = options.readonly || [];
  var data = options.data || {};

  var keys = _keys.call(this);

  for(var i = 0; i < keys.length; i++){

    let key = keys[i];

    if(key.indexOf('_') === 0){

      if(readonly.indexOf(key) !== -1){
        _setNoneEnumerableAndReadOnly.call(this, key);
      }else{
        _setNoneEnumerable.call(this, key);
      }

    }else if(key === 'className' || readonly.indexOf(key) !== -1){

      _setReadOnly.call(this, key);

    }

  }

  if(!data) return this;

  set.call(this, data);

  return this;

}

function toString(){

  const keys = _keys.call(this);
  const baseKeys = _keys.call(Base());

  var properties = keys.filter((key) => {
    return typeof this[key] !== 'function'
      && baseKeys.indexOf(key) === -1;
  }).map((key) => {
    return _propertyDescription.call(this, key);
  });

  var functions = keys.filter((key) => {
    return typeof this[key] === 'function'
      && baseKeys.indexOf(key) === -1;
  }).map((key) => {
    return _functionDescription.call(this, key);
  });

  var log = '[Object ' + this.className + ']';
  log += '\n\n' + properties.join('\n');
  log += '\n\n' + functions.join('\n');

  return log;

}

export default {get, set, init, toString, setReadOnly};



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/helpers.js
 **/